import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import useMetrics from 'src/metrics/useUserMetrics';
import { useSellerContext } from 'src/hooks/useSellerContext';
import { Header } from './navigation';
import { useClientId } from '../contexts/ClientContext';
import { FeatureName } from '../metrics/metricsFields';

export const SU_APP_TEST_ID = 'seller-university';

// Custom hook to handle website metrics tracking
const useWebsiteMetrics = () => {
  const { viewMetric } = useMetrics();
  const clientId = useClientId();

  useEffect(() => {
    viewMetric({
      feature: FeatureName.Website,
      metadata: { clientId },
    });
  }, [viewMetric, clientId]);
};

const NewApp = () => {
  // Fetch seller context on app initialization
  // This provides sessionId, customerId, merchantId for metrics and tracking
  useSellerContext();

  useWebsiteMetrics();

  return (
    <div data-testid={SU_APP_TEST_ID}>
      <Header />
      <div className="m-auto max-w-screen-lg p-su-page-padding">
        <Outlet />
      </div>
    </div>
  );
};

const App = () => {
  return NewApp();
};

export default App;
